import React, { useState } from "react"

export default function Toggle(props) {

    const [selected, setSelected] = useState(props.default ? props.default : false);

    // on toggle off, set external state to deadline = null
    // on toggle on, set external state to local value
    const handleToggle = () => {
        props.edit();
        setSelected(!selected);
    }

    return (
        <div className={props.wrapperClass}>
            <label htmlFor={props.id} className="content2 light gap-right-s">{props.label}</label>
            <div className="iblock">
                <div
                    id={props.id}
                    className={"toggle-container" + (selected ? " active" : "")}
                    role="checkbox"
                    aria-checked={selected}
                    tabIndex={props.tabIndex}
                    onClick={() => handleToggle()}
                    style={{verticalAlign: "text-bottom"}}
                    >
                    <div id="toggle-button" className={selected ? "toggle-button active" : "toggle-button"}></div>
                </div>
            </div>
        </div>
    )
}
